import { VerificationPartner } from "./VerificationPartner";
import { VerificationPackageDetail } from "./VerificationPackage";
import { DataTableColumn } from "../../../shared/components/data-table/DataTableColumn.model";

export interface VerificationPackageCheckType {
    id: number;
    code: string;
    display_order: number;
    display_text: string;
    created_date?: Date;
    updated_date?: Date;
}

export interface VerificationPackageCheckTypeByIdResponse {
    id: number;
    name: string;
    description: string;
    check_type?: VerificationPackageCheckType[];
    package: VerificationPackageDetail[];
    partner: VerificationPartner;
    created_date: Date;
    updated_date: Date;
}

export const VerificationCheckTypesColumns: DataTableColumn[] = [
    { column: 'id', display: 'ID' },
    { column: 'checkType', display: 'Check Type' },
    { column: 'partnerName', display: 'Provided By' },
    { column: 'verificationCheckTypeButtons', display: '' }
]

export const getVerificationCheckTypeRowFromPackage = (verificationCheckType: any): any => {
    return {
        id: verificationCheckType.id,
        checkType: verificationCheckType.check_type.code + ' - ' + verificationCheckType.check_type.display_text,
        partnerName: verificationCheckType.partner.name
    }
}